export const defaultInitialState = {
  list: [],
  idsList: [],
  listPage: 1,
  listTotalCount: 0,
  loadingList: false,
  loadedList: false,
  listError: null,
  show: null,
  showId: null,
  loadingShow: false,
  loadedShow: false,
  showError: null,
  creating: false,
  created: false,
  createError: null,
  createSuccess: null,
  errorsObject: null,
  dictionary: {},
  payloadToString: "",
  filtersDictionary: {},
  showPayloadToString: "",
  cachedShowDictionary: {},
};
